import Error from '@material-ui/icons/Error';
import { push } from 'connected-react-router';

import { actionCreators as userFormActions } from 'redux/userFormHandlers';
import { CLAIM } from 'constants/userForms';
import { ROUTES } from 'constants/routes';
import { appConfig } from 'config/customization';
import { message } from 'utils/stringUtils';

const OUTAGE = 'outage';
const COMMERCIAL = 'commercial';

export const alertFlavours = {
  [OUTAGE]: {
    action: {
      label: message('Alerts:createNewClaim'),
      onClick: dispatch =>
        dispatch(userFormActions.createForm(appConfig.accountAlerts.claimFormId, CLAIM, ROUTES.NEW_FORM))
    },
    Icon: Error
  },
  [COMMERCIAL]: {
    action: {
      label: message('Alerts:payYourDebt'),
      onClick: dispatch => dispatch(push(ROUTES.PAYMENTS))
    },
    Icon: Error
  }
};
